const doc = [({"da":({"js":({"admin":({"teams":({"edit":({"add_new_team":"Tilføj nyt hold", "edit_team":"Redigér hold: %{name}", "the_team_was_saved":"Holdet blev gemt"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;